import { useCallback } from 'react';

import { NativeResources } from '@ariksa/inventory-core';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';

import { useFlags } from 'app/flagsmith';
import { featureFlags, isFeatureEnabled } from 'app/flagsmith/features';
import { actions as sharedStateActions } from 'containers/SharedState/slice';
import { actions } from 'containers/Visibility/Vulnerabilities/slice';

export const useResourceVulnerabilities = (props: { uuid: string }) => {
  const dispatch = useDispatch();
  const { new_vuln_dashboard: vulnerabilityV3Flag } = useFlags([
    featureFlags.vulnerabilityV3,
  ]);
  const useScanVaultVulnerabilityFindings = isFeatureEnabled(
    vulnerabilityV3Flag,
  );

  const getResourceVulnerabilities = useCallback(() => {
    if (!props.uuid) return;
    dispatch(
      actions.getResourceInsight({
        q: {
          insightV2Request: {
            resource_uuids: [props.uuid],
          },
        },
        onSuccess: res => {
          const insight = res?.items?.[0];
          if (!isEmpty(insight)) {
            dispatch(
              sharedStateActions.getSecurityGraphAvailability({
                q: { resources: [insight?.native_name] },
              }),
            );
            dispatch(
              actions.getResourceDetails({
                q: {
                  resourceUuid: insight.uuid,
                  resourceType: insight.native_name,
                  account: insight.account,
                },
              }),
            );
            dispatch(
              actions.getResourceVulnerabilityCount({
                q: {
                  resourceVulnerabilitiesRequest: {
                    resource_ids: [insight.uuid],
                    native_resource: insight.native_name,
                    account_ids: [insight.account],
                  },
                },
              }),
            );

            const isContainer = [
              NativeResources.Container,
              NativeResources.GcpContainer,
              NativeResources.AzureContainer,
            ].includes(insight?.native_name as any);

            dispatch(
              actions.getResourceVulnerabilitySummary({
                q: {
                  instanceId: isContainer ? undefined : insight.resource_id,
                  containerId: isContainer ? insight.resource_id : undefined,
                  resourceUuid: props.uuid,
                  useScanVaultVulnerabilityFindings,
                },
              }),
            );
            dispatch(
              sharedStateActions.getRiskContext({
                q: {
                  riskContextRequest: {
                    uuids: [props.uuid],
                  },
                },
              }),
            );
          }
        },
      }),
    );

    /*dispatch(
      actions.getResourceAlertCount({
        q: {
          requestBody: [params.id],
        },
      }),
    );*/
  }, [props.uuid, dispatch, useScanVaultVulnerabilityFindings]);

  return { getResourceVulnerabilities };
};
